import { Button } from '@oysterjs/ui/button';
import { Spinner } from '@oysterjs/ui/spinner';

/**
 * Step one's shape while detection runs, so the picker fills in where its rows were
 * rather than replacing a spinner of a different height.
 */
export function StepOneSkeleton(props: { onCancel: () => void }) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-3">
        <Spinner size="size-4" color="sky" />
        <p className="m-0 text-sm/6 text-neutral-500 dark:text-neutral-400">
          Finding the account and policies this document is about
        </p>
      </div>

      <section className="flex flex-col gap-2" aria-hidden="true">
        <h3 className="text-sm font-semibold text-neutral-800 dark:text-neutral-200">
          AMS account
        </h3>
        <SkeletonBar className="h-2.5 w-3/5" />
        <div className="h-9 rounded-lg border border-neutral-200 dark:border-neutral-700" />
        <div className="overflow-hidden rounded-lg border border-neutral-200 dark:border-neutral-700">
          <SkeletonRow title="w-1/2" detail="w-2/3" />
          <SkeletonRow title="w-2/5" detail="w-1/2" />
        </div>
      </section>

      <section className="flex flex-col gap-2" aria-hidden="true">
        <h3 className="text-sm font-semibold text-neutral-800 dark:text-neutral-200">
          Write destinations
        </h3>
        <SkeletonBar className="h-2.5 w-1/2" />
        <div className="overflow-hidden rounded-lg border border-neutral-200 dark:border-neutral-700">
          <div className="border-b border-neutral-200 bg-neutral-50 px-3 py-2 dark:border-neutral-700 dark:bg-neutral-900">
            <SkeletonBar className="h-2.5 w-1/3" />
          </div>
          <SkeletonRow title="w-2/5" detail="w-3/5" />
          <SkeletonRow title="w-1/3" detail="w-1/2" />
          <SkeletonRow title="w-2/5" detail="w-3/5" />
        </div>
      </section>

      <div className="flex justify-end gap-2">
        <Button type="button" color="white" onClick={props.onCancel}>
          Cancel
        </Button>
        <Button type="button" color="sky" disabled>
          Continue
        </Button>
      </div>
    </div>
  );
}

function SkeletonRow(props: { title: string; detail: string }) {
  return (
    <div className="flex flex-col gap-1.5 border-b border-neutral-100 p-3 last:border-b-0 dark:border-neutral-800">
      <SkeletonBar className={`h-3.5 ${props.title}`} />
      <SkeletonBar className={`h-2.5 ${props.detail}`} />
    </div>
  );
}

function SkeletonBar(props: { className: string }) {
  return (
    <div
      className={`animate-pulse rounded bg-neutral-100 dark:bg-neutral-700 ${props.className}`}
    />
  );
}
